import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_accessorial_code_editor___ds_accessorial_code_editorService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { accessorial_code_id: number }): 
  Promise<{ result: { Id?: number, BillingCodeId?: number, Description?: string, Name?: string } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.accessorial_code_id)) {
      $missingRequiredInParams.push('\'accessorial_code_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      accessorial_code_id: number    }) {
        if(isNil($inParams.accessorial_code_id)) {
          return true; 
        }
      return false;
    }
}
